import { useMemo } from 'react';
import { useGetMeSubscription } from '@bpm-web-app/swr-hooks';
import ModalSlider from '../modal-slider/modal-slider';
import BPMS_1 from '../../../assets/onboarding/supreme-bundle/1.gif';
import BPMS_2 from '../../../assets/onboarding/supreme-bundle/2.gif';
import BPMS_3 from '../../../assets/onboarding/supreme-bundle/3.gif';

export function BPMSupremeCreateBundle() {
    const { data: subscription } = useGetMeSubscription('create');

    const data = useMemo(
        () => {
            if (subscription && subscription.data.membership.is_supreme_bundle) {
                return [
                    {
                        image: BPMS_1,
                        title: 'You now get BPM Create for free.',
                        text: 'As part of your All-Access subscription, you now get full access to BPM Create, our top-tier music production platform, at no extra cost. No strings. No surprise charges. Just another way we’ve got your back.'
                    },
                    {
                        image: BPMS_2,
                        title: 'Your BPM Create free plan includes:',
                        text: '450 credits per month to download samples, loops, MIDI files & synth presets. Access to exclusive sound packs made by industry pros across every genre. And a robust platform to search, filter and find exactly what you’re looking for.'
                    },
                    {
                        image: BPMS_3,
                        title: 'Start Creating',
                        text: 'You don’t need to sign up, upgrade, or pay anything extra. Your BPM Create access is already live. Just log in and start exploring. Start making your own edits, remixes & more. Get in, get inspired, and create something amazing.',
                        // eslint-disable-next-line @typescript-eslint/dot-notation
                        href: `${process.env['NEXT_PUBLIC_CREATE_PLATFORM_URL']}`,
                        hrefText: 'Go to BPM Create'
                    }
                ];
            }
            return [];
        },
        [subscription]
    );

    if (!data.length) {
        return null;
    }

    return <ModalSlider title="New Benefits" type="BPMSupremeCreateBundle" sliderItems={data} />;
}

export default BPMSupremeCreateBundle;
